import { validationErrors } from "../utils";
import ajaxService from "./ajax-service";

class LogService {

  async fetch(page) {
    const response = await ajaxService.get(`/logs?page=${page}`);
    if (response ?? false) {
      return response
    } else {
      const errors = response.data.errors;
      return validationErrors(errors);
    }
  }

}
const logService = new LogService();
export default logService;